import { getLibraryFileId, isAnalyzedRegularUpload } from './librarySuggestion';

// 설정 화면에서 동의를 바꾸면 같은 화면의 '지난 채팅 파일 모으기' 카드가 다시 확인한다.
export const AI_REFERENCE_CONSENT_EVENT = 'wq:ai-reference-consent-changed';

// 자료함 자동 모으기 대상과 같은 문서 형식. 이미지·음성은 묻지 않는다.
export const AI_REFERENCE_DOC_EXTENSIONS = new Set(['hwp', 'hwpx', 'pdf', 'docx', 'xlsx', 'pptx', 'txt']);

const fileExtension = (file) => {
  const name = String(file?.name || file?.filename || file?.original_filename || '');
  const dot = name.lastIndexOf('.');
  return dot >= 0 ? name.slice(dot + 1).toLowerCase() : '';
};

/** 동의 카드를 띄울 만한 첨부(분석이 끝난 일반 문서)를 고른다. 없으면 null. */
export const pickAiReferenceConsentFile = (files) => {
  if (!Array.isArray(files)) return null;
  return files.find((file) => (
    isAnalyzedRegularUpload(file) && AI_REFERENCE_DOC_EXTENSIONS.has(fileExtension(file))
  )) || null;
};

export const buildAiReferenceConsentSuggestion = (file) => {
  const fileId = getLibraryFileId(file);
  return {
    id: `ai_reference_consent:${fileId || 'turn'}`,
    type: 'ai_reference_consent',
    title: '채팅에 올린 파일과 지난 대화를 AI가 필요할 때 찾아 쓸까요?',
    description: '파일은 내 자료함에 모아 두고, 학생 이름 등은 가린 채로 참고해요.\nAI 맞춤 설정에서 언제든 바꿀 수 있어요.',
    primary: { label: '허용', action: 'allow_ai_reference' },
    secondary: { label: '허용 안 함', action: 'decline_ai_reference' },
    acceptedLabel: '이제 채팅 파일과 지난 대화를 필요할 때 찾아 쓸게요',
    payload: { fileId },
  };
};

/** 서버가 묻기로 한 상태(should_prompt)이고 기능이 켜져 있을 때만 카드를 띄운다. */
export const shouldOfferAiReferenceConsent = (consentPayload) => Boolean(
  consentPayload?.feature_enabled && consentPayload?.should_prompt
);

// 생기부·상담 대화의 첨부는 서버가 자동으로 모으지 않는다 (services/library_auto_collect.py 와 같은 목록).
export const AUTO_COLLECT_EXCLUDED_CATEGORIES = new Set([
  'record',
  'counseling_care',
  'student_counseling',
  'teacher_care',
]);

/** 이 대화의 문서 첨부를 서버가 자료함에 자동으로 모으는 상태인지. */
export const isLibraryAutoCollectOn = (consentPayload, category) => Boolean(
  consentPayload?.feature_enabled
  && consentPayload?.consent?.library_auto_collect?.enabled === true
  && !AUTO_COLLECT_EXCLUDED_CATEGORIES.has(String(category || ''))
);
